import { Langfuse, LangfuseWeb } from 'langfuse'

import { LANGFUSE_SYNAP_METADATA_BASE } from './telemetry-metadata'
import { runTelemetrySafely } from './telemetry.helpers'

const EU_DEFAULT_HOST = 'https://cloud.langfuse.com'

let client: LangfuseWeb | null = null
let tracingClient: Langfuse | null = null
let disabled = false

export const isBrowserLangfuseEnabled = (): boolean => {
  if (disabled) return false
  const publicKey = import.meta.env.VITE_LANGFUSE_PUBLIC_KEY?.trim()
  return Boolean(publicKey)
}

const getLangfuseBaseUrl = (): string =>
  (import.meta.env.VITE_LANGFUSE_HOST?.trim() || EU_DEFAULT_HOST).replace(/\/+$/, '')

export const getBrowserLangfuseClient = (): LangfuseWeb | null => {
  if (disabled || typeof window === 'undefined') return null
  if (client) return client
  const publicKey = import.meta.env.VITE_LANGFUSE_PUBLIC_KEY?.trim()
  if (!publicKey) {
    disabled = true
    return null
  }
  client = new LangfuseWeb({
    publicKey,
    baseUrl: getLangfuseBaseUrl(),
    flushAt: 5,
    flushInterval: 5_000,
  })
  return client
}

/** Cliente com `trace()` / spans — necessário para pipeline de anamnese no browser. */
export const getBrowserLangfuseTracingClient = (): Langfuse | null => {
  if (disabled || typeof window === 'undefined') return null
  if (tracingClient) return tracingClient
  const publicKey = import.meta.env.VITE_LANGFUSE_PUBLIC_KEY?.trim()
  if (!publicKey) {
    disabled = true
    return null
  }
  tracingClient = new Langfuse({
    publicKey,
    baseUrl: getLangfuseBaseUrl(),
    flushAt: 5,
    flushInterval: 5_000,
  })
  return tracingClient
}

export const flushBrowserLangfuse = (): void => {
  runTelemetrySafely(() => {
    void getBrowserLangfuseClient()?.flushAsync()
    void getBrowserLangfuseTracingClient()?.flushAsync()
  })
}

export const shutdownBrowserLangfuse = (): void => {
  runTelemetrySafely(() => {
    void getBrowserLangfuseClient()?.shutdownAsync()
    void getBrowserLangfuseTracingClient()?.shutdownAsync()
    client = null
    tracingClient = null
  })
}

export const buildBrowserLangfuseBaseMetadata = (
  extra: Record<string, string | number | boolean | null> = {},
): Record<string, string | number | boolean | null> => ({
  ...LANGFUSE_SYNAP_METADATA_BASE,
  synap_runtime: 'browser',
  ...extra,
})
